var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Container } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import React from "react";
import { usePriceList } from "@/react/Webshop/providers/PriceListProvider";
import Icon from "@material-ui/core/Icon";
import { formatCurrency } from "@/react/utils";
import makeStyles from "@material-ui/core/styles/makeStyles";
const useStyles = makeStyles((theme) => ({
    subProductList: {
        padding: 0,
        margin: 0,
        listStyle: "none",
        "& > li": {
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            borderBottom: "1px solid #BFBFBF",
        },
    },
    productRow: {
        display: "flex",
        alignItems: "center",
    },
    iconButton: {
        width: "40px",
        height: "40px",
        border: "none",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        flexShrink: 0,
    },
    quantity: {
        boxSizing: "border-box",
        width: "40px",
        height: "40px",
        textAlign: "center",
        fontSize: "18px",
        fontWeight: "bold",
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    productName: {
        marginLeft: theme.spacing(1),
        fontSize: "15px",
    },
    productPriceContainer: {
        display: "flex",
        fontSize: "12px",
    },
    productPrice: {},
    oldPrice: {
        textDecoration: "line-through",
        marginLeft: theme.spacing(2),
    },
    totalSummary: {
        fontSize: "18px",
        fontWeight: "bold",
        display: "flex",
        borderBottom: "1px solid #BFBFBF",
        paddingBottom: "3px",
        "& > *": {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            borderBottom: "1px solid #BFBFBF",
        },
    },
    totalQuantityContainer: {
        width: 40 + 40 + 40 + theme.spacing(1) + theme.spacing(1),
        textAlign: "center",
    },
    totalPriceContainer: {
        paddingLeft: theme.spacing(1),
        flexGrow: 1,
    },
}));
export const BuyProductView = ({ product, quantity, setQuantity, totalQuantity, totalPrice, qualifyForPromotedPrice, hasCampaignPrice, }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const increaseQuantity = (uuid) => () => {
        setQuantity((prev) => {
            const val = prev[uuid] || 0;
            return Object.assign(Object.assign({}, prev), { [uuid]: Math.max(val + 1, product.minorderpartquantity) });
        });
    };
    const decreaseQuantity = (uuid) => () => {
        setQuantity((prev) => {
            const val = prev[uuid] || 0;
            return Object.assign(Object.assign({}, prev), { [uuid]: Math.max(val - 1, 0) });
        });
    };
    const handleBlur = (uuid) => {
        return (e) => {
            let num = parseInt(e.target.value);
            setQuantity((quantity) => {
                if (!Number.isInteger(num)) {
                    num = 0;
                }
                else if (num < product.minorderpartquantity) {
                    num = 0;
                }
                return Object.assign(Object.assign({}, quantity), { [uuid]: num });
            });
        };
    };
    const handleChange = (uuid) => (e) => {
        setQuantity((prev) => (Object.assign(Object.assign({}, prev), { [uuid]: parseInt(e.target.value) || 0 })));
    };
    return (React.createElement(Container, { maxWidth: "sm" },
        product.subproducts && product.subproducts.length > 0 && (React.createElement(SubProductList, { product: product, subProducts: product.subproducts, handleChange: handleChange, handleBlur: handleBlur, increaseQuantity: increaseQuantity, decreaseQuantity: decreaseQuantity, quantity: quantity, hasCampaignPrice: hasCampaignPrice, qualifyForPromotedPrice: qualifyForPromotedPrice })),
        (!product.subproducts || product.subproducts.length == 0) && (React.createElement(BuyProduct, { product: product, hasCampaignPrice: hasCampaignPrice, handleChange: handleChange, handleBlur: handleBlur, increaseQuantity: increaseQuantity, decreaseQuantity: decreaseQuantity, quantity: quantity, qualifyForPromotedPrice: qualifyForPromotedPrice })),
        React.createElement("div", { className: classes.totalSummary },
            React.createElement("div", { className: classes.totalQuantityContainer }, t("%d pcs", { postProcess: "sprintf", sprintf: [totalQuantity] })),
            React.createElement("div", { className: classes.totalPriceContainer }, t("Sum %s", {
                postProcess: "sprintf",
                sprintf: [formatCurrency(totalPrice)],
            })))));
};
const SubProductList = (_a) => {
    var { product, quantity, subProducts } = _a, rest = __rest(_a, ["product", "quantity", "subProducts"]);
    const classes = useStyles();
    return (React.createElement("div", null,
        React.createElement("ul", { className: classes.subProductList }, subProducts.map((subproduct) => {
            return (React.createElement(OrderSubProductItem, Object.assign({ key: subproduct.uuid, uuid: subproduct.uuid, subproduct: subproduct, productName: `${product.name} ${subproduct.name}`, product: product, quantity: quantity }, rest)));
        }))));
};
const BuyProduct = (_a) => {
    var { product, quantity } = _a, rest = __rest(_a, ["product", "quantity"]);
    const classes = useStyles();
    return (React.createElement("div", null,
        React.createElement("ul", { className: classes.subProductList },
            React.createElement(OrderSubProductItem, Object.assign({ uuid: product.uuid, productName: product.name, product: product, quantity: quantity }, rest)))));
};
const OrderSubProductItem = ({ productName, product, subproduct, uuid, hasCampaignPrice, handleChange, quantity, handleBlur, increaseQuantity, decreaseQuantity, qualifyForPromotedPrice, }) => {
    var _a, _b, _c;
    const classes = useStyles();
    const { calculateLinePrice } = usePriceList();
    const { t } = useTranslation();
    const ppu = calculateLinePrice(product.uuid, quantity[uuid], subproduct === null || subproduct === void 0 ? void 0 : subproduct.uuid, false, qualifyForPromotedPrice);
    const cppu = calculateLinePrice(product.uuid, quantity[uuid], subproduct === null || subproduct === void 0 ? void 0 : subproduct.uuid, hasCampaignPrice, qualifyForPromotedPrice);
    return (React.createElement("li", null,
        React.createElement("div", { className: classes.productRow },
            React.createElement("button", { className: classes.iconButton, onClick: decreaseQuantity(uuid), "aria-label": (_a = t("Decrease quantity")) !== null && _a !== void 0 ? _a : "" },
                React.createElement(Icon, null, "remove")),
            React.createElement("input", { type: "text", className: classes.quantity, value: typeof quantity[uuid] == "undefined" ? 0 : quantity[uuid], onChange: handleChange(uuid), onBlur: handleBlur(uuid), "aria-label": (_b = t("Quantity")) !== null && _b !== void 0 ? _b : "" }),
            React.createElement("button", { className: classes.iconButton, onClick: increaseQuantity(uuid), "aria-label": (_c = t("Increase quantity")) !== null && _c !== void 0 ? _c : "" },
                React.createElement(Icon, null, "add")),
            React.createElement("div", { className: classes.productName },
                productName,
                React.createElement("div", { className: classes.productPriceContainer },
                    hasCampaignPrice && (React.createElement("div", null, t("%s/pcs", {
                        postProcess: "sprintf",
                        sprintf: [formatCurrency(cppu)],
                    }))),
                    React.createElement("div", { className: `${classes.productPrice} ${hasCampaignPrice ? classes.oldPrice : ""}` }, t("%s/pcs", {
                        postProcess: "sprintf",
                        sprintf: [formatCurrency(ppu)],
                    })))))));
};
